import { useSelector } from 'react-redux';
import { Badge } from 'antd';
import type { RootState } from 'store';

interface CountUnreadInboxBadgeProps {
  collapsed?: boolean;
}

const CountUnreadInboxBadge = ({ collapsed }: CountUnreadInboxBadgeProps) => {
  const unreadCounter = useSelector((store: RootState) => store.inbox.unreadCounter);

  if (!unreadCounter) return null;

  if (collapsed) {
    return <Badge count={unreadCounter} size="small" title="" style={{ position: 'absolute', right: '-20px', bottom: '0px' }} />;
  }

  return <Badge count={unreadCounter} title="" />;
};

export default CountUnreadInboxBadge;
